import { createTransport } from "@empite/api-client";
import { createQueryClient } from "./query.js";
/**
 * bootApp builds the router context: one QueryClient and one Transport for
 * the life of the page.
 *
 * Built once, at module scope, and never inside a component — a QueryClient
 * recreated on a render throws away every cached page and re-requests the
 * whole portal, which looks like a slow API and is actually a slow client.
 */
export function bootApp(options = {}) {
    const transport = createTransport({
        baseUrl: options.baseUrl ?? "",
        onUnauthenticated: options.onUnauthenticated ? () => options.onUnauthenticated?.() : undefined,
    });
    return { queryClient: createQueryClient(), transport };
}
//# sourceMappingURL=boot.js.map